module.exports = __webpack_public_path__ + "static/img/big_pop_bg.40f2d62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/big_pop_bg.png
// module id = rUEO
// module chunks = 2